import type { Option } from '@neo/blocks/faceted-filter'
import { capitalize, humanize } from 'inflection'
import { useMemo, useState } from 'react'

export function useTagFilter<T>(items: T[], getTags: (item: T) => string[]) {
  const [selectedTags, setSelectedTags] = useState<string[]>([])

  const tagOptions: Option[] = useMemo(() => {
    const tagSet = new Set<string>()
    for (const item of items) {
      for (const tag of getTags(item)) tagSet.add(tag)
    }
    return Array.from(tagSet)
      .sort()
      .map((tag) => ({ label: capitalize(humanize(tag)), value: tag }))
  }, [items, getTags])

  const filtered = useMemo(() => {
    if (selectedTags.length === 0) return items
    const tagSet = new Set(selectedTags)
    return items.filter((item) => getTags(item).some((t) => tagSet.has(t)))
  }, [items, selectedTags, getTags])

  return { tagOptions, selectedTags, setSelectedTags, filtered }
}
